import React, { useCallback } from 'react';
import { useStore } from 'effector-react';
import { currProduct$ } from 'models/product';
import QuantityChanger from 'pages/Product/MainBlock/QuantityPanel/QuantityChanger';
import MainReservationBtn from 'pages/Product/MainReservationBtn';

import style from './quantityPanel.module.scss';

const QuantityPanel = ({
  selectingDetails,
  setSelectingDetails,
  isMaxQuantityReached,
  handleAddProduct,
  mainBtnRef,
  isBottomBtn,
  isBookNowDisabled,
  postcodeError,
  isTotalPriceLoading,
}) => {
  const product = useStore(currProduct$);

  const changeCount = useCallback(
    (count) => {
      setSelectingDetails((currDetails) => ({
        ...currDetails,
        count,
      }));
    },
    [setSelectingDetails],
  );

  return (
    <div
      className={
        isBottomBtn
          ? style.quantityChangerWrapperBottomBtn
          : style.quantityChangerWrapper
      }
    >
      <QuantityChanger
        startCount={selectingDetails.count}
        changeCount={changeCount}
        limit={isMaxQuantityReached}
        minQuantity={1}
        maxQuantity={product.max_quantity}
        isDisable={isTotalPriceLoading}
      />
      <div
        ref={mainBtnRef}
        className={
          isBottomBtn
            ? style.mainButtonWrapperBottomBtn
            : style.mainButtonWrapper
        }
      >
        <MainReservationBtn
          handleAddProduct={handleAddProduct}
          product={product}
          isMaxQuantityReached={isMaxQuantityReached}
          isBookNowDisabled={isBookNowDisabled}
          postcodeError={postcodeError}
        />
      </div>
    </div>
  );
};

export default QuantityPanel;
